// Onboarding routes
import Welcome from "@pages/login/Welcome";
import Login from "@pages/login/Login";
import Register from "@pages/login/Register";
// Dashboard tab
import Dashboard from "@pages/dashboard/Dashboard";
import HelpCentre from "@pages/dashboard/HelpCentre";
import HelpCentreDetails from "@pages/dashboard/HelpCentreDetails";
import ContactUs from "@pages/dashboard/ContactUs";
import Info from "@pages/dashboard/Info";
import ProgramHome from "@pages/programs/ProgramHome";
import ProgramSkillPage from "@pages/programs/ProgramSkillPage";
import StandardPage from "@pages/programs/StandardPage";
import ProgramDetails from "@pages/programs/ProgramDetails";
import RoleAndTeamSetup from "@pages/programs/RoleAndTeamSetup";
import ProgressCheckPage from "@pages/programs/ProgressCheckPage";
import LearningOutcomesPage from "@pages/programs/LearningOutcomesPage";
import ProgramSkillsPage from "@pages/programs/ProgramSkillsPage";
import ProgramSkillsPageRenfrew from "@pages/programs/ProgramSkillsPageRenfrew";
import MedicalImagingPage from "@pages/programs/MedicalImagingPage";
import WPBAPage from "@pages/programs/WPBAPage";
import ProgramCertificatesPage from "@pages/programs/ProgramCertificatesPage";
import Comments from "@pages/programs/Comments";
import WellbeingActivity from "@pages/programs/WellbeingActivity";
import WellbeingResults from "@pages/programs/WellbeingResults";
import AbsenceConversation from "@pages/programs/AbsenceConversation";
import NQPLearningOutcomesPage from "@pages/programs/NQPLearningOutcomesPage";
import ProgramSkillsLogPage from "@pages/programs/ProgramSkillsLogPage";
import ProgramSkillsTopSectionPage from "@pages/programs/ProgramSkillsTopSectionPage";
// Timeline tab
import Timeline from "@pages/timeline/Timeline";
// Evidence tab
import Evidence from "@pages/evidence/Evidence";
// Profile tab
import Profile from "@pages/profile/Profile";
import AppInfo from "@pages/profile/AppInfo";
import EditRole from "@pages/profile/EditRole";
import Accessibility from "@pages/profile/Accessibility";
import SummaryOfWork from "@pages/profile/SummaryOfWork";
import PersonalStatement from "@pages/profile/PersonalStatement";
import Account from "@pages/profile/Account";
import ReadEvidence from "@pages/evidence/ReadEvidence";
import ProgramDataInfo from "@pages/dashboard/ProgramDataInfo";

export type OnboardingRouteType = {
  path: string;
  component?: React.ComponentType;
  redirect?: string;
};

export type TabRouteType = {
  path: string;
  component?: React.ComponentType;
  redirect?: string;
};

export type TabType = {
  tab: string;
  href: string;
};

export type MenuRouteType = {
  title: string;
  icon?: string;
  href: string;
  path: string;
  component?: React.ComponentType;
};

export const onboardingRoutes: OnboardingRouteType[] = [
  {
    path: "/login",
    redirect: "/onboarding",
  },
  {
    path: "/onboarding",
    component: Welcome,
  },
  {
    path: "/onboarding/login",
    component: Login,
  },
  {
    path: "/onboarding/register",
    component: Register,
  },
];

export const tabRoutes: TabRouteType[] = [
  // Dashboard
  {
    path: "/:tab(dashboard)",
    component: Dashboard,
  },
  {
    path: "/dashboard/help-centre",
    component: HelpCentre,
  },
  {
    path: "/dashboard/help-centre/:pageId",
    component: HelpCentreDetails,
  },
  {
    path: "/dashboard/help-centre/contact-us",
    component: ContactUs,
  },
  {
    path: "/dashboard/program-data-info",
    component: ProgramDataInfo,
  },
  {
    path: "/dashboard/info/:pageId",
    component: Info,
  },
  {
    path: "/dashboard/program/:programId",
    component: ProgramHome,
  },
  {
    path: "/dashboard/program/:programId/program-skills-log/:skillSlug/:topSectionSlug",
    component: ProgramSkillsTopSectionPage,
  },
  {
    path: "/dashboard/program/:programId/program-skills-log/:skillSlug",
    component: ProgramSkillsLogPage,
  },
  {
    path: "/dashboard/program/:programId/:skillId",
    component: ProgramSkillPage,
  },
  {
    path: "/dashboard/program/:programId/standard/:standardId",
    component: StandardPage,
  },
  {
    path: "/dashboard/program/:programId/read/:evidenceId",
    component: ReadEvidence,
  },
  {
    path: "/dashboard/program/:programId/details",
    component: ProgramDetails,
  },
  {
    path: "/dashboard/program/:programId/role-team-setup",
    component: RoleAndTeamSetup,
  },
  {
    path: "/dashboard/program/:programId/:skillId/read/:evidenceId",
    component: ReadEvidence,
  },
  {
    path: "/dashboard/program/:programId/progress-check/:progressCheckId",
    component: ProgressCheckPage,
  },
  {
    path: "/dashboard/program/:programId/progress-check/:progressCheckId/comp/:compId",
    component: LearningOutcomesPage,
  },
  {
    path: "/dashboard/program/:programId/learning-outcomes",
    component: NQPLearningOutcomesPage,
  },
  {
    path: "/dashboard/program/:programId/skills",
    component: ProgramSkillsPage,
  },
  {
    path: "/dashboard/program/:programId/skills/:sectionSlug",
    component: ProgramSkillsPageRenfrew,
  },
  {
    path: "/dashboard/program/:programId/medical-imaging",
    component: MedicalImagingPage,
  },
  {
    path: "/dashboard/program/:programId/wpba-forms",
    component: WPBAPage,
  },
  {
    path: "/dashboard/program/:programId/certificates",
    component: ProgramCertificatesPage,
  },
  {
    path: "/dashboard/program/:programId/progress-check/:progressCheckId/comments",
    component: Comments,
  },
  {
    path: "/dashboard/program/:programId/progress-check/:progressCheckId/read/:evidenceId",
    component: ReadEvidence,
  },
  {
    path: "/dashboard/program/:programId/progress-check/:progressCheckId/wellbeing-activity/:competenceId",
    component: WellbeingActivity,
  },
  {
    path: "/dashboard/program/:programId/progress-check/:progressCheckId/wellbeing-activity/:competenceId/results/:evidenceId",
    component: WellbeingResults,
  },
  {
    path: "/dashboard/program/:programId/absence-conversation/",
    component: AbsenceConversation,
  },
  // Timeline
  {
    path: "/:tab(timeline)",
    component: Timeline,
  },
  // Evidence
  {
    path: "/:tab(evidence)",
    component: Evidence,
  },
  {
    path: "/evidence/read/:evidenceId",
    component: ReadEvidence,
  },
  // Profile
  {
    path: "/:tab(profile)",
    component: Profile,
  },
  {
    path: "/profile/edit",
    component: EditRole,
  },
  {
    path: "/profile/app-info",
    component: AppInfo,
  },
  {
    path: "/profile/summary-of-work",
    component: SummaryOfWork,
  },
  {
    path: "/profile/personal-statement",
    component: PersonalStatement,
  },
  // Common
  {
    path: "/",
    redirect: "/dashboard",
  },
];

export const tabs: TabType[] = [
  {
    tab: "dashboard",
    href: "/dashboard",
  },
  {
    tab: "timeline",
    href: "/timeline",
  },
  {
    tab: "evidence",
    href: "/evidence",
  },
  {
    tab: "profile",
    href: "/profile",
  },
];

export const menuRoutes: MenuRouteType[] = [
  {
    title: "Account",
    href: "/profile/account",
    path: "/profile/account",
    component: Account,
  },
  {
    title: "Help centre",
    href: "/dashboard/help-centre",
    path: "/dashboard/help-centre",
    component: HelpCentre,
  },
  {
    title: "Accessibility",
    href: "/profile/accessibility",
    path: "/profile/accessibility",
    component: Accessibility,
  },
  {
    title: "Contact us",
    href: "/dashboard/contact-us",
    path: "/dashboard/contact-us",
    component: ContactUs,
  },
  {
    title: "App information",
    href: "/profile/app-info",
    path: "/profile/app-info",
    component: AppInfo,
  },
];
